var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotInUse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5C27 24.8281 24.3047 27.5 21 27.5C17.6719 27.5 15 24.8281 15 21.5C15 18.1953 17.6719 15.5 21 15.5C24.3047 15.5 27 18.1953 27 21.5ZM17.1562 18.4766C16.5 19.3203 16.125 20.375 16.125 21.5C16.125 24.1953 18.3047 26.375 21 26.375C22.125 26.375 23.1797 26 24.0234 25.3438L17.1562 18.4766ZM25.875 21.5C25.875 18.8281 23.6719 16.625 21 16.625C19.8516 16.625 18.7969 17.0234 17.9531 17.6797L24.8203 24.5469C25.4766 23.7031 25.875 22.6484 25.875 21.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInUse);
export default __webpack_public_path__ + "static/media/notInUse.0f031a6a22f8766bd43dc60be2e8129b.svg";
export { ForwardRef as ReactComponent };